<template>
    <div id="computer">
        <topBox :title="title" />
        <div class="w-full pb-[65px] mt-[15px] mb-[55px] mx-auto overflow-y-auto bg-local">

          <div class="video-stage mx-[10px] mt-[44px]">
            <!-- 1. 封面：整卡点击即进广告或正片并开播 -->
            <div
              v-if="playPhase === 'poster'"
              class="poster-stage"
              role="button"
              tabindex="0"
              @click="startWithAd"
              @keydown.enter.prevent="startWithAd"
              @keydown.space.prevent="startWithAd"
            >
              <img
                v-if="posterUrl"
                :src="posterUrl"
                class="poster-img"
                alt=""
              />
              <div v-else class="poster-placeholder">加载中...</div>
              <button
                type="button"
                class="poster-play-btn"
                :disabled="!src"
                aria-label="播放"
                @click.stop="startWithAd"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </button>
              <div v-if="isPreview" class="preview-tip preview-tip--on-cover">
                当前为残缺版本，完整版请充值
              </div>
            </div>

            <!-- 2. 广告：10 秒倒计时，可点击跳转 -->
            <div v-else-if="playPhase === 'ad'" class="ad-stage">
              <video-player
                key="ad-player"
                :src="adSrc"
                :controls="false"
                :autoplay="true"
                :loop="false"
                :volume="0.6"
                :playsinline="true"
                width="355"
                height="266"
                class="ad-player"
                @ready="onAdReady"
                @timeupdate="onAdTimeupdate"
                @ended="onAdEnded"
              />
              <div
                class="ad-click-layer"
                :class="{ 'ad-click-layer--link': adLink }"
                :role="adLink ? 'link' : undefined"
                :tabindex="adLink ? 0 : undefined"
                @click="openAdLink"
                @keydown.enter="openAdLink"
              >
                <span class="ad-countdown">{{ adCountdown }}</span>
                <span v-if="adLink" class="ad-tip">广告 · 点击查看</span>
                <span v-else class="ad-tip">广告</span>
              </div>
            </div>

            <!-- 3. 正片：autoplay，避免封面点一次还要再点才播 -->
            <video-player
              v-else-if="playPhase === 'main' && src"
              key="main-player"
              :src="src"
              :poster="posterUrl"
              controls
              :autoplay="true"
              :loop="false"
              :volume="0.6"
              :playsinline="true"
              width="355"
              height="266"
              class="main-player"
              @ready="onMainReady"
              @waiting="waitPlay"
              @ended="endPlay"
            />
          </div>

          <div v-if="isPreview" class="preview-banner">
            当前视频是残缺版本，完整版请充值
          </div>

        </div>
        <div class="video-title-line">{{ video_title || title }}</div>
       
        <ZonePay :amount="this.$route.query.amount" :video="video_id" />  
    </div>
</template>


<script>
import { useI18n } from 'vue-i18n'
import topBox from "@/components/computer/TopBox.vue"
// import mainMenu from "@/components/computer/MainMenu.vue"
import ZonePay from "@/components/computer/PayZone.vue"
import axios from 'axios'
import { layer } from "vue3-layer"

import { VideoPlayer } from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

import { useRoute } from 'vue-router'
import format from '@/assets/js/formatDate'
// 使用全局变量
import { useGlobalStore } from '@/assets/js/globalStore'

export default {
    components: {
        topBox,
        // mainMenu,
        // videoPlay,
        VideoPlayer,
        ZonePay,
    },
    setup() {
        const route = useRoute()
        const { ym } = format()
        return {
            video_title: route.query.title,
            video_id: route.query.id,
            video_cover: route.query.cover,
            video_time: route.query.time,
            ad_src_query: route.query.ad_src,
            ad_link_query: route.query.ad_link,
            ym,
        }
    },
    data() {
        return {
          src: '',
          title: this.$t('page.play'),
          uploadProgress: 0,
          domain: process.env.VUE_APP_VIDEO,
          playPhase: 'poster', // poster | ad | main
          adSrc: '',
          adLink: '',
          adDuration: 10,
          adCountdown: 10,
          posterFromApi: '',
          video_cover_path: '',
          pendingPlay: false,
          second: 0, // 0=完整版；非0=残缺/试看版
        }
    },
    computed: {
        posterUrl() {
            return this.video_cover_path || this.posterFromApi || ''
        },
        // second 不为 0 时为残缺版本，需提示充值看完整版
        isPreview() {
            return Number(this.second) !== 0
        },
    },
    mounted() {
        // console.log( this.src )
        // this.playCreate()
        // 切换语言
        const { locale } = useI18n()  // 从国际化中取出配置项 locale 因为初始化时 用户没有指定语种 要使用系统默认的语种
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : locale.value // 如果用户有选择特定语种 就使用用户指定的 不然就使用系统默认的
        locale.value = this.lang
        // 仅当路径里是真实会员 uuid（36 位）时才记入邀请关系。
        // 列表进播放页会带占位符 /uuid，绝不能 setInvite('uuid')，否则注册会误传 invite 并校验失败。
        const inviteUuid = String(this.$route.params.uuid ?? '').trim()
        if (inviteUuid && inviteUuid !== '0' && inviteUuid.toLowerCase() !== 'uuid' && inviteUuid.length === 36) {
            useGlobalStore().setInvite(inviteUuid)
        }
        // 通过 Token 去调取帐号相关信息，即时。
        // this.getInfo()

        // console.log( `video_id : ${this.video_id}` )
        // 开始向后端接口发起请求，看当前用户是否有权限查看完整版本的视频。
        // 如果有，则返回视频的完整链接地址，前端直接播放。
        // 如果没有，则返回视频的预览链接地址，前端直接播放。
        this.getInfo()
        return {}
    },
    methods: {
        onUse(type) {
          if (type == 'demux') {
            this.config.demuxUseWorker = !this.config.demuxUseWorker
          } else if (type == 'band') {
            this.config.showBandwidth = !this.config.showBandwidth
          } else if (type == 'hasAudio') {
            this.config.hasAudio = !this.config.hasAudio
          } else {
            this.config.useMSE = false
            this.config.useSIMD = false
            this.config.useWCS = false
            if (type == 'useMSE') this.config.useMSE = true
            if (type == 'useSIMD') this.config.useSIMD = true
            if (type == 'useWCS') this.config.useWCS = true
          }
          if (this.isPlay) {
            this.onDestroy().then(() => {
              this.playCreate();
              this.onPlayer()
            });
          }
        },
        setFullscreen() {
          this.playerInfo.setFullscreen(true)
        },
        onPause() {
          this.playerInfo.pause()
        },
        onMute() {
          this.playerInfo.mute()
        },
        onPlayer() {
          this.isPlay = true
          setTimeout((url) => {
            this.playerInfo && this.playerInfo.play(url).then(() => {
            }).catch((e) => {
              console.error(e);
            });
          }, 0, this.videoUrl)
        },
        onPlayerPlayback() {
          setTimeout((url) => {
              this.playerInfo && this.playerInfo.playback(url, {
                controlType: "simple",
                showRateBtn: true,
                showControl: true,
                isUseLocalCalculateTime: true, // 是否使用本地时间来计算playback时间
                playbackPause: false,
                useMSE: true,
                rateConfig: [
                  { label: "正常", value: 1 },
                  { label: "2倍", value: 2 },
                  { label: "4倍", value: 4 },
                  { label: "8倍", value: 8 },
                  { label: "16倍", value: 16 },
                ],
              }).then(() => {

              }).catch((e) => {
                console.error(e);
              });
          }, 0, this.videoUrl)
        },
        onStop() {
          this.isPlay = false
          this.onDestroy().then(() => {
            this.playCreate();
          });
        },
        onDestroy() {
            // eslint-disable-next-line
            let _this = this
            // eslint-disable-next-line
            return new Promise((resolve, reject) => {
                if (this.playerInfo) {
                this.playerInfo.destroy()
                this.playerInfo = null
                }
                setTimeout(() => {
                resolve();
                }, 100);
            })
        },
        // eslint-disable-next-line
        onReplay(type) {
          this.onDestroy().then(() => {
            this.playCreate();
            this.onPlayer()
          });
        },
        playCreate() {
          var container = document.getElementById('player_box1');
          // eslint-disable-next-line
          var easyplayer = new EasyPlayerPro({
            container: container,
            decoder: './js/decoder-pro.js',
            videoBuffer: 0.2, // 缓存时长
            isResize: false,
            text: "",
            loadingText: "加载中",
            // debug: true,
            // debugLevel: 'debug',
            useMSE: true,
            // eslint-disable-next-line
            useSIMD: false,
            useWCS: true,
            isMulti: true,
            // eslint-disable-next-line
            useSIMD: this.config.useSIMD,
            hasAudio: this.config.hasAudio,
            showBandwidth: this.config.showBandwidth, // 显示网速
            showPerformance: this.config.showBandwidth,
            operateBtns: {
              fullscreen: true,
              screenshot: true,
              play: true,
              audio: true,
              record: true,
              quality: true,
              performance: true,
            },
            watermarkConfig: {
              text: {
                content: 'easyplayer-pro'
              },
              right: 10,
              top: 10
            },
            playbackForwardMaxRateDecodeIFrame: 1,
            isWebrtcForOthers:true,
            demuxUseWorker: true,
            supportHls265:true,
          });

          easyplayer.on("fullscreen", function (flag) {
            // eslint-disable-next-line
            console.log('is fullscreen', id, flag)
          })
          easyplayer.on('playbackPreRateChange', (rate) => {
            easyplayer.forward(rate);
          })

          easyplayer.on('playbackSeek', (data) => {
            easyplayer.setPlaybackStartTime(data.ts);
          })
          this.playerInfo = easyplayer
        },
        startWithAd() {
            if (!this.src) {
                layer.msg('视频加载中，请稍候')
                return
            }
            this.pendingPlay = true
            // 仅当 API 下发了 ad_link 时才播广告，否则直接正片并开播
            if (this.adLink) {
                this.playPhase = 'ad'
                this.adCountdown = Number(this.adDuration) || 10
            } else {
                this.playPhase = 'main'
            }
        },
        onAdReady(payload) {
            this.tryStartPlayer(payload)
        },
        onAdTimeupdate(payload) {
            const player = payload?.player ?? payload
            if (!player?.currentTime) return
            const current = player.currentTime()
            const remaining = Math.ceil(this.adDuration - current)
            this.adCountdown = Math.max(0, remaining)
            if (current >= this.adDuration) {
                player.pause()
                this.onAdEnded()
            }
        },
        onAdEnded() {
            this.pendingPlay = true
            this.playPhase = 'main'
            this.adCountdown = this.adDuration
        },
        onMainReady(payload) {
            this.tryStartPlayer(payload)
        },
        /** 封面点击后切阶段会丢用户手势，需主动 play；失败则静音再播再恢复音量 */
        tryStartPlayer(payload) {
            const player = payload?.player ?? payload
            if (!player || typeof player.play !== 'function') return
            if (!this.pendingPlay && this.playPhase !== 'ad') return

            const start = async () => {
                try {
                    const ret = player.play()
                    if (ret && typeof ret.then === 'function') await ret
                    this.pendingPlay = false
                } catch (e) {
                    try {
                        if (typeof player.muted === 'function') player.muted(true)
                        else if ('muted' in player) player.muted = true
                        const ret2 = player.play()
                        if (ret2 && typeof ret2.then === 'function') await ret2
                        if (typeof player.muted === 'function') player.muted(false)
                        else if ('muted' in player) player.muted = false
                        this.pendingPlay = false
                    } catch (e2) {
                        // 仍失败则留给控件二次点击
                    }
                }
            }
            this.$nextTick(() => {
                setTimeout(start, 0)
            })
        },
        openAdLink() {
            if (this.adLink) {
                window.open(this.adLink, '_blank', 'noopener,noreferrer')
            }
        },
        applyVideoInfo(data) {
            this.second = Number(data.second) || 0
            this.src = data.url_path || ''
            // API 字段是 cover_path（完整 URL），不是 poster / cover_url
            this.video_cover_path = data.cover_path || ''
            this.posterFromApi = data.cover_path || data.poster || data.cover_url || ''
            // ad_link 有值才启用广告；无 link 则清空广告片源，跳过广告阶段
            const adLink = String(data.ad_link || data.ad_href || this.ad_link_query || '').trim()
            this.adLink = adLink
            this.adSrc = adLink
                ? (data.ad_video_url || data.ad_video || data.ad_src || this.ad_src_query || '')
                : ''
            if (data.ad_duration != null && data.ad_duration !== '') {
                this.adDuration = Number(data.ad_duration) || 10
                this.adCountdown = this.adDuration
            }
        },
        waitPlay() {
          console.log( '用户在切换进度条' )
        },
        endPlay() {
          console.log( '结束播放' )
        },
        
        doClick() {
            // console.log('ok')
        },
        onSubmit() {
            this.$route.to('/recharge')
        },
        // 得到这个用户请求播放的视频信息
        getInfo()
        {
            // const globalStore = useGlobalStore()
            // console.log(`globalStore.invite (${globalStore.invite})`)

            // console.log(`访问打开，记录下推荐人的UUID ${this.$route.params.uuid}`)
            // 如果付入的参数，有推荐人的令牌。要将令牌记录下来，如果访问这个视频的人注册，则建立上下级关系。
            // 但是用令牌，有一个麻烦点，用户退出时，令牌会消失，的以这里应该用推存人的 UUID。
            axios.post(
                '/api/play', 
                {
                  // video_id: this.video_id // 传入要购买的视频ID，后端根据这个ID判断这个视频的价格，以及这个用户是否有权限观看完整版本。
                  video_id: this.$route.params.id,
                  token: this.$route.params.token 
                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                // console.log(response.data)
                if (0===response.data.code) {
                    let info = response.data.data // 创建一个临时变量，免得每次用的时候，变量名太长。
                    // console.log(`info`)
                    // console.log(info.id)

                    // 使用全局变量，需要在止之前引入
                    // import { useGlobalStore } from '@/assets/js/globalStore'
                    const globalStore = useGlobalStore()
                    globalStore.setId(info.uid) // 将帐号的流水ID记录到全局变量中，方便其他页面使用。主要是推存给好友时，和于建立上下级关系时使用。
                    // 同上：忽略路由占位符 "uuid"，只写入合法邀请码
                    const routeInvite = String(this.$route.params.uuid ?? '').trim()
                    if (routeInvite && routeInvite !== '0' && routeInvite.toLowerCase() !== 'uuid' && routeInvite.length === 36) {
                        globalStore.setInvite(routeInvite)
                    }

                    this.title = info.title // 将后端传递过来的标题，转交给本视图变量，应用到顶部标题栏，进行显示。
                    this.applyVideoInfo(response.data.data)
                } else {
                    // let word = response.data.data.id
                    // let key = word.charAt(0).toUpperCase() + word.slice(1)
                    // // 转成国际化 后端转提示语 前端转表单名称
                    // let msg = this.$t(`input.${key}`) + ' ' + response.data.msg 
                    layer.msg(response.data.msg)
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        },
        // End 得到这个用户的基本信息
        out() {
            // localStorage.removeItem('token')
            axios.post(
                '/api/m/out', 
                {

                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                if (0===response.data.code) {
                    localStorage.removeItem('token')
                    // this.$router.go(0) // 刷新本页
                    // 跳转
                    this.$router.push({
                        path: '/computer/login',
                        query: {
                            msg: 'account out'
                        }
                    })
                } else {
                    layer.msg( response.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }, // End out() 退出系统
        // 提交视频及附属信息
        runSubmit() {
            console.log('提交视频及附属信息')

            // 正在提交中，请等待...
            axios.post(
                '/api/m/video', 
                {
                  video: this.form.video,
                },
                {
                  headers: {
                    'Content-Type': 'multipart/form-data', // multipart/form-data，以支持文件上传
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept-Language': this.lang,
                    'token': localStorage.getItem('token')
                  },
                  
                }
            )
            .then((response) =>  {
                if (0===response.data.code) {
                    // localStorage.removeItem('token')
                    // this.$router.go(0) // 刷新本页
                    // 跳转
                    // this.$router.push({
                    //     path: '/computer/login',
                    //     query: {
                    //         msg: 'account out'
                    //     }
                    // })
                } else {
                    layer.msg( response.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })

        }, // End runSubmit() 提交视频及附属信息
    }
}
</script>

<style>
.focus {
    /* background-image: url('/public/upload/600.png'); */
    background-repeat: no-repeat; /** 图片不要平铺 */
    background-size: 100% 190px; /** 因为用大一倍的图，才够清晰，但是如果不定义自适应，只能显示一半的图片。所以宽度给 100% 但高度要给它限制 */
}
.ql-toolbar {
    @apply p-[1px];
    height: auto;
    font-size: 12px;
}


  /* color: #07baf4; */
  * {
    margin: 0;
    padding: 0;
  }

  p {
    line-height: 24px;
  }



  .radio-container {
    padding: 10px 0;
  }

  .radio-item {
    cursor: pointer;
    display: inline-block;
    padding: 6px 12px;
    margin-right: 15px;
    border-radius: 4px;
    border: 1px #ccc solid;
  }

  .radio-active {
    color: #fff;
    background-color: #07baf4;
    border-color: #07baf4;
  }

  .player_container {
    display: grid;
  }

  .player_container_1 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .player_item {
    position: relative;
    padding-bottom: 56%;
    background-color: #000;
    border: 1px #fff solid;
  }

  .inputs {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
    max-width: 600px;
    margin-right: 16px;
  }

  .player_box {
    height: 100%;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  .df {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .df span {
    margin-left: 4px;
  }

  .df form {
    margin-right: 4px;
  }

  .video-stage {
    width: 355px;
    height: 266px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    background: #000;
    overflow: hidden;
  }

  /* 与播放器同宽：16 个汉字约 16*18=288px，可单行放下 */
  .video-title-line {
    width: 355px;
    margin: 12px auto 0;
    padding: 0 4px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    line-height: 1.35;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .poster-stage,
  .ad-stage {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .poster-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .poster-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 14px;
  }

  .poster-play-btn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .poster-play-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .poster-play-btn svg {
    width: 28px;
    height: 28px;
    margin-left: 4px;
  }

  .ad-stage .ad-player,
  .main-player {
    width: 100%;
    height: 100%;
  }

  .ad-click-layer--link {
    cursor: pointer;
  }

  .ad-click-layer {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    padding: 10px;
    box-sizing: border-box;
  }

  .ad-countdown {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    padding: 0 8px;
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    font-size: 13px;
    text-align: center;
  }

  .ad-tip {
    font-size: 12px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    padding: 4px 8px;
    border-radius: 4px;
  }

  .preview-tip--on-cover {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    padding: 8px 10px;
    box-sizing: border-box;
    text-align: center;
    font-size: 13px;
    line-height: 1.4;
    color: #fff;
    background: rgba(0, 0, 0, 0.72);
    pointer-events: none;
  }

  .preview-banner {
    width: 355px;
    margin: 10px auto 0;
    padding: 8px 12px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    line-height: 1.4;
    color: #b45309;
    background: #fff7ed;
    border: 1px solid #fdba74;
  }
</style>